import { useEffect } from "react";
import { fetchCatalog } from "../api/catalog";

const SELECTOR = 'link[data-store-favicon="true"]';

function removeStoreFavicon() {
  document.head.querySelector(SELECTOR)?.remove();
}

function applyStoreFavicon(url) {
  removeStoreFavicon();
  if (!url) return;
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = url;
  link.dataset.storeFavicon = "true";
  document.head.appendChild(link);
}

export default function StoreFavicon({ storeSlug }) {
  useEffect(() => {
    const controller = new AbortController();
    removeStoreFavicon();

    fetchCatalog(storeSlug, {
      page: 1,
      limit: 1,
      signal: controller.signal,
    })
      .then((catalog) => applyStoreFavicon(catalog?.store?.faviconUrl))
      .catch((error) => {
        if (error.name !== "AbortError") removeStoreFavicon();
      });

    return () => {
      controller.abort();
      removeStoreFavicon();
    };
  }, [storeSlug]);

  return null;
}
